import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FaqSection() {
  const revealRef = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cuánto tarda en manifestarse el cambio?',
    a: 'Muchos lectores reportan cambios perceptibles en los primeros 7 días de práctica constante. La velocidad depende de tu nivel de entrega al proceso.'
  }, {
    q: '¿Funciona si tengo traumas muy graves?',
    a: 'Especialmente si tienes traumas graves. La profundidad del abismo determina la altura del vuelo. El quiebre profundo es el combustible más potente.'
  }, {
    q: '¿Cómo recibo el protocolo?',
    a: 'Inmediatamente después del pago recibes un correo con el enlace de descarga en PDF. Revisa spam si no aparece en 5 minutos.'
  }, {
    q: '¿Para quién es este protocolo?',
    a: 'Para personas de 30 a 55 años que han intentado terapia, libros y afirmaciones y siguen repitiendo los mismos patrones. No necesitas saber nada de física cuántica.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Garantía total 7 días. Te devolvemos el dinero completo sin preguntas.'
  }];
  return <section className="bg-brand-cream py-[60px] md:py-[100px] px-[5%]" data-id="element-49">
      <div ref={revealRef} className="max-w-7xl mx-auto reveal" data-id="element-50">
        <div className="text-center mb-[56px]" data-id="element-51">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-52">
            PREGUNTAS FRECUENTES
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-ink leading-tight" data-id="element-53">
            Todo lo que necesitas saber
          </h2>
        </div>

        <div className="max-w-[700px] mx-auto" data-id="element-54">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border-b border-brand-ink/10" data-id="element-55">
                <button className="w-full flex justify-between items-center py-[24px] text-left group" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-56">
                  <span className="font-body text-[17px] font-medium text-brand-ink transition-colors duration-300 group-hover:text-brand-gold" data-id="element-57">
                    {faq.q}
                  </span>
                  <span className={`text-brand-gold text-[24px] transition-transform duration-300 leading-none ${isOpen ? 'rotate-45' : ''}`} data-id="element-58">
                    +
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-59">
                  <p className="font-body font-light text-[15px] text-brand-ink/60 leading-[1.7] pb-[24px]" data-id="element-60">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}